module.exports = __webpack_public_path__ + "img/hero3.66e3db68.webp";